import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DocumentDeleteConfirmDialogLabels {
  title: string;
  description: string;
  cancel: string;
  confirm: string;
  confirming: string;
}

interface DocumentDeleteConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  labels: DocumentDeleteConfirmDialogLabels;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export function DocumentDeleteConfirmDialog({
  open,
  onOpenChange,
  labels,
  onConfirm,
  isDeleting = false,
}: DocumentDeleteConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{labels.title}</AlertDialogTitle>
          <AlertDialogDescription>{labels.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>{labels.cancel}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? labels.confirming : labels.confirm}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
